import { autoinject } from 'aurelia-framework';
import { ServiceReportService } from 'services/service-report-service';
import { ServiceStationService } from 'services/service-station-service';
import { ApplicationState } from 'lib/state';
import { connectTo } from 'aurelia-store';

@autoinject
@connectTo()
export class ServiceKpiEstimatesServiceQueue {
  private state: ApplicationState;
  private serviceStationId: number;
  private tableData = [];
  private serviceStations: Array<any>;
  private ready: boolean = false;

  constructor(private serviceReportService: ServiceReportService, private serviceStationService: ServiceStationService) {}

  async attached() {
    this.serviceStations = await this.serviceStationService.getAll();
    this.serviceStationId = this.state.user.ServiceStationId;

    this.ready = false;
    this.tableData = await this.serviceReportService.getServiceKpiEstimatesServiceQueue(this.serviceStationId);
    this.ready = true;
  }

  async setServiceStation(id: number) {
    if (this.serviceStationId === id) return Promise.resolve();

    this.serviceStationId = id;

    this.ready = false;
    this.tableData = await this.serviceReportService.getServiceKpiEstimatesServiceQueue(this.serviceStationId);
    this.ready = true;
  }
}
